// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__8iXab","footer":"ModalError_footer__2EaQk"};